var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 4.33329C1.66675 3.07621 1.66675 2.44767 2.05727 2.05715C2.4478 1.66663 3.07634 1.66663 4.33341 1.66663C5.59049 1.66663 6.21903 1.66663 6.60956 2.05715C7.00008 2.44767 7.00008 3.07621 7.00008 4.33329C7.00008 5.59037 7.00008 6.21891 6.60956 6.60944C6.21903 6.99996 5.59049 6.99996 4.33341 6.99996C3.07634 6.99996 2.4478 6.99996 2.05727 6.60944C1.66675 6.21891 1.66675 5.59037 1.66675 4.33329Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.6667C9 10.4096 9 9.78105 9.39052 9.39052C9.78105 9 10.4096 9 11.6667 9C12.9237 9 13.5523 9 13.9428 9.39052C14.3333 9.78105 14.3333 10.4096 14.3333 11.6667C14.3333 12.9237 14.3333 13.5523 13.9428 13.9428C13.5523 14.3333 12.9237 14.3333 11.6667 14.3333C10.4096 14.3333 9.78105 14.3333 9.39052 13.9428C9 13.5523 9 12.9237 9 11.6667Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 11.6667C1.66675 10.4096 1.66675 9.78105 2.05727 9.39052C2.4478 9 3.07634 9 4.33341 9C5.59049 9 6.21903 9 6.60956 9.39052C7.00008 9.78105 7.00008 10.4096 7.00008 11.6667C7.00008 12.9237 7.00008 13.5523 6.60956 13.9428C6.21903 14.3333 5.59049 14.3333 4.33341 14.3333C3.07634 14.3333 2.4478 14.3333 2.05727 13.9428C1.66675 13.5523 1.66675 12.9237 1.66675 11.6667Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.33329C9 3.07621 9 2.44767 9.39052 2.05715C9.78105 1.66663 10.4096 1.66663 11.6667 1.66663C12.9237 1.66663 13.5523 1.66663 13.9428 2.05715C14.3333 2.44767 14.3333 3.07621 14.3333 4.33329C14.3333 5.59037 14.3333 6.21891 13.9428 6.60944C13.5523 6.99996 12.9237 6.99996 11.6667 6.99996C10.4096 6.99996 9.78105 6.99996 9.39052 6.60944C9 6.21891 9 5.59037 9 4.33329Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardView);
export default __webpack_public_path__ + "static/media/cardView.8cd1c0686b5e156062b173bd37137944.svg";
export { ForwardRef as ReactComponent };